import { render } from "./componentEdit.vue?vue&type=template&id=17057570"
import script from "./componentEdit.vue?vue&type=script&lang=js"
export * from "./componentEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__